import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "@mui/material/Button";
import StarRating from "./StarRating";
import TextContent from "./TextContent";
import classes from './ListItem.module.css';
import { useState } from "react";

const ListItem = ({
  id,
  name,
  apy,
  logo,
  advertiser_notes,
  link,
  rating,
  effective_at,
  member,
  min_to_open,
  buttonTitle,
  product,
  isCheckwrite,
  monthlyService,
  offerDetails,
  minToAvoidFee,
}) => {
  const isWealthfront = name.toLowerCase().includes('wealthfront');
  const isCashApp = name.toLowerCase().includes('cash app');

  let displayProduct = product;
  if (isWealthfront) {
    displayProduct = 'CASH ACCOUNT';
  }

  let displayMember = '';
  if (member) {
    displayMember = `Member ${member}`;
  }
  if (isWealthfront) {
    displayMember = 'CASH ACCOUNT';
  }
  if (isCashApp) {
    displayMember = 'FDIC insurance eligibility through Program Banks Wells Fargo Bank, N.A. and/or Sutton Bank, Members FDIC';
  }

  const [showArrow, setShowArrow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const handleToggleDetails = () => {
    setShowDetails(!showDetails)
  };

  const handleToggleButtonArrowIcon = () => {
    setShowArrow(!showArrow)
  };

  const handleTraceInfo = (event) => {
    event.preventDefault()

    window.dataLayer.push({
      'lender_name': name,
      'product_name': 'Savings',
      'rank_order': id,
      'event': 'bankrateDepositsClick'
    });

    window.open(link, "_blank");
  };

  return (
    <div className={classes.container} key={id}>
      <div className={classes.complianceTag}>
        <p>{displayProduct}</p>
      </div>
      <div className={classes.mainContent}>
        <div className={classes.leftContainer}>
          <div className={classes.logoContainer}>
            <img
              loading="lazy"
              src={`https://www.brimg.net/system/img/inst/${logo}`}
              alt={`${name}`}
            />
          </div>
        </div>
        <div className={classes.middleContainer}>
          <TextContent apy={apy} effective_at={effective_at} min_to_open={min_to_open} rating={rating} />
        </div>
        <div className={classes.rightContainer}>
          <Button
            onMouseEnter={handleToggleButtonArrowIcon}
            onMouseLeave={handleToggleButtonArrowIcon}
            endIcon={showArrow ? <ArrowForwardIcon /> : null}
            onClick={handleTraceInfo}
            sx={{
              backgroundColor: "#2da83e !important",
              borderRadius: "4px",
              textTransform: "uppercase",
              fontFamily: "Outfit, sans-serif",
              width: "140px",
              height: "50px",
              transition: "0.5s",
              color: "#fff",
              "&:hover": {
                boxShadow: '0px 0px 0px 5px rgba(0, 0, 0, 0.2)',
                transition: '0.5s'
              }
            }}
          >
            {buttonTitle}
          </Button>
        </div>
      </div>
      <div className={classes.infoWrapper}>
        {member && <p>{displayMember}</p>}
        <StarRating rating={rating} />
      </div>
      <div className={classes.resultContainer}>
        <p>
          Promoted Offer{
            advertiser_notes &&
            <span>: {" "}
              <a href={link} target="_blank" rel="noreferrer" onClick={handleTraceInfo}>
                {advertiser_notes}
              </a>
            </span>
          }
        </p>
      </div>
      <hr className={classes.mainSpacer} />
      <div className={classes.detailsBox} onClick={handleToggleDetails}>
        <p className={classes.detailsLink}>Product Details</p>
        <ArrowDownwardOutlinedIcon fontSize="small" />
      </div>
      {showDetails &&
        (
          <div className={classes.detailsContainer}>
            <h4>{product.charAt(0).toUpperCase() + product.slice(1)} account details</h4>
            <p>Offer valid as of: <span>{effective_at}</span></p>
            <hr />
            <p>Minimum balance to avoid fees: <span>${minToAvoidFee}</span></p>
            <hr />
            <p>Monthly fee: <span>${monthlyService}</span></p>
            <hr />
            <p>Check writing: <span>{isCheckwrite ? 'Yes' : 'No'}</span></p>
            {offerDetails &&
              (
                <>
                  <h4>Current promotion</h4>
                  <div dangerouslySetInnerHTML={{ __html: offerDetails }} />
                </>
              )
            }
          </div>
        )
      }
    </div>
  );
};

export default ListItem;
